export const movies = [
  {
    id: "m01",
    title: "红房间的记忆",
    titleJa: "赤い部屋の記憶",
    year: 2019,
    director: "佐野川 透",
    cast: ["三浦 绫", "高桥 圭", "大西 千夏"],
    runtime: 104,
    region: "东京",
    categories: ["classic", "drama"],
    tags: ["室内剧", "记忆", "昭和"],
    rating: 8.6,
    popularity: 96,
    releaseDate: "2019-11-08",
    synopsis:
      "一间只在深夜开放的旧公寓，成为两个人反复回到的坐标。时间在这里失去刻度，只剩下墙上逐渐褪色的红色墙纸。",
    story:
      "影片开场是一段长达四分钟的空镜：走廊尽头那扇门半掩着，红色的墙面在钨丝灯下泛出近乎褐色的温度。导演佐野川透用几乎固定的机位，让观众与主角一起被关进这间房间。\n\n故事并不依赖情节推进，而是依靠重复：同一个动作、同一句台词、同一段唱片的沙沙声，在三个不同的季节里被重新演奏。每一次重复都改变一点点细节，观众需要自己辨认究竟哪一次才是真实的记忆。结尾处窗帘被风掀起，房间第一次见到日光，也第一次显得空荡。",
    poster:
      "https://readdy.ai/api/search-image?query=Moody%20art%20house%20film%20poster%2C%20deep%20crimson%20curtain%20in%20a%20dim%20tatami%20room%2C%20single%20shaft%20of%20light%2C%20charcoal%20shadows%2C%20cinematic%20film%20grain%2C%20no%20text&width=600&height=900&seq=jpf-p01&orientation=portrait",
    stills: [
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20red%20wall%20in%20a%20dark%20corridor%20with%20warm%20lamp%20glow%2C%20shallow%20depth%20of%20field%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p01-s1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20old%20vinyl%20record%20player%20spinning%20in%20dim%20room%2C%20dust%20in%20light%20beam%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p01-s2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20sheer%20white%20curtain%20lifting%20in%20wind%20with%20morning%20light%2C%20warm%20muted%20tones%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p01-s3&orientation=landscape",
    ],
  },
  {
    id: "m02",
    title: "雨后",
    titleJa: "雨のあとで",
    year: 2023,
    director: "小林 澪",
    cast: ["西岛 玲", "松本 悠真"],
    runtime: 98,
    region: "京都",
    categories: ["new", "drama", "romance"],
    tags: ["梅雨", "京都", "久别重逢"],
    rating: 8.9,
    popularity: 99,
    releaseDate: "2023-09-15",
    synopsis:
      "梅雨结束的那个下午，两个十年未见的人在京都的石板路上重逢。雨停了，有些话却始终没有落地。",
    story:
      "小林澪把整部影片压缩在一天之内：从午后骤雨到黄昏放晴，两个人沿着鸭川一路走，谈话断断续续。摄影使用大量手持跟拍，镜头始终略微落后于人物，仿佛观众是那个不敢靠近的第三人。\n\n最动人的段落发生在旧书店的檐下。雨水顺着屋檐滴落，两人沉默地站着，谁也没有提起当年那封没有寄出的信。影片结尾，放晴后的路面蒸腾起薄雾，其中一人转身走进巷子，另一人继续走向车站。没有音乐，只有远处的电车声。",
    poster:
      "https://readdy.ai/api/search-image?query=Moody%20film%20poster%2C%20rain%20soaked%20narrow%20stone%20alley%20in%20Kyoto%20at%20dusk%2C%20wet%20reflections%2C%20muted%20crimson%20lantern%20glow%2C%20cinematic%20grain%2C%20no%20text&width=600&height=900&seq=jpf-p02&orientation=portrait",
    stills: [
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20rain%20drops%20on%20a%20wooden%20eaves%20in%20Kyoto%20old%20street%2C%20soft%20overcast%20light%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p02-s1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20river%20bank%20after%20rain%20with%20wet%20stones%20and%20mist%2C%20muted%20green%20and%20grey%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p02-s2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20empty%20train%20platform%20at%20dusk%20with%20warm%20lamps%2C%20lonely%20mood%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p02-s3&orientation=landscape",
    ],
  },
  {
    id: "m03",
    title: "黎明的口红",
    titleJa: "夜明けの口紅",
    year: 2021,
    director: "早川 佳奈",
    cast: ["青木 沙耶", "藤井 修"],
    runtime: 112,
    region: "大阪",
    categories: ["romance", "drama", "retro"],
    tags: ["夜班", "都市", "女性视角"],
    rating: 8.2,
    popularity: 88,
    releaseDate: "2021-06-04",
    synopsis:
      "在大阪的深夜酒吧里，一位调酒师与常客之间维持着一种无需命名的关系。天一亮，一切就要重新开始。",
    story:
      "影片几乎全部发生在夜间营业的酒吧里，霓虹灯透过磨砂玻璃渗进来，把整间店染成暗红色。早川佳奈用固定长镜头记录调酒的动作：冰块、酒液、擦拭杯口，这些重复的手势构成影片的节奏。\n\n两位主角的对话极其节制，多数时候只是并排坐着。中段有一段长达七分钟的独白，讲的是十九岁时第一次独自坐上新干线的心情。观众会突然意识到，这部影片真正讲述的是一个人如何学会与孤独相处。天光出现时，镜头第一次切到室外，街道干净得像什么都没发生过。",
    poster:
      "https://readdy.ai/api/search-image?query=Moody%20film%20poster%2C%20vintage%20lipstick%20on%20a%20dark%20dressing%20table%20mirror%2C%20amber%20lamp%20light%2C%20deep%20shadows%2C%20cinematic%20film%20grain%2C%20no%20text&width=600&height=900&seq=jpf-p03&orientation=portrait",
    stills: [
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20cocktail%20glass%20on%20a%20dark%20bar%20counter%20with%20red%20backlight%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p03-s1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20neon%20bar%20sign%20reflected%20on%20rainy%20Osaka%20street%20at%20night%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p03-s2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20dawn%20light%20over%20an%20empty%20city%20street%20with%20closed%20shutters%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p03-s3&orientation=landscape",
    ],
  },
  {
    id: "m04",
    title: "玻璃女人",
    titleJa: "硝子の女",
    year: 2017,
    director: "黑田 诚一",
    cast: ["水野 香织", "中村 隆"],
    runtime: 121,
    region: "东京",
    categories: ["noir", "drama", "classic"],
    tags: ["黑色电影", "都市", "心理"],
    rating: 8.7,
    popularity: 91,
    releaseDate: "2017-03-24",
    synopsis:
      "一桩发生在高层公寓的失踪案，让一名调查者不断逼近一个他不愿承认的真相。玻璃之外，城市永远在说谎。",
    story:
      "黑田诚一在这部作品中把黑色电影的语汇推到极致：百叶窗、烟灰缸、停在半空的电梯。摄影指导大量使用反射，人物总是先以倒影出现，然后才是本人。玻璃既是布景也是隐喻，所有人都隔着一层看不见的介质在观察彼此。\n\n叙事上影片刻意留下缺口，观众与主角同时被误导。真正的转折并不来自线索，而来自一次长达两分钟的对视。结尾镜头缓慢拉远，整栋大楼的窗格亮起又熄灭，像一块巨大的电路板。",
    poster:
      "https://readdy.ai/api/search-image?query=Moody%20film%20poster%2C%20cracked%20glass%20pane%20with%20distorted%20reflection%20of%20a%20dark%20city%2C%20cold%20grey%20and%20crimson%20tones%2C%20cinematic%20grain%2C%20no%20text&width=600&height=900&seq=jpf-p04&orientation=portrait",
    stills: [
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20venetian%20blind%20shadows%20on%20a%20dark%20apartment%20wall%2C%20noir%20lighting%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p04-s1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20rainy%20city%20lights%20seen%20through%20a%20wet%20window%20at%20night%2C%20bokeh%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p04-s2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20empty%20hotel%20elevator%20corridor%20with%20cold%20fluorescent%20light%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p04-s3&orientation=landscape",
    ],
  },
  {
    id: "m05",
    title: "夏日残响",
    titleJa: "夏の残響",
    year: 2022,
    director: "篠原 直",
    cast: ["坂本 未来", "井上 隼人"],
    runtime: 107,
    region: "湘南",
    categories: ["new", "romance"],
    tags: ["海岸", "夏天", "青春"],
    rating: 8.4,
    popularity: 94,
    releaseDate: "2022-07-22",
    synopsis:
      "湘南的夏天，一间即将拆迁的海边旅馆，和两个把整个季节都耗在走廊上的人。蝉声停下之前，有些事必须说完。",
    story:
      "篠原直把整部电影拍成了夏天的质感：过曝的天空、贴在皮肤上的衬衫、永远化开的冰棒。旅馆是主要场景，木地板被海风侵蚀出细小的响声，摄影机经常停在空无一人的走廊上等人物走进画面。\n\n影片中段插入一段几乎无声的段落：两人在夜里走进海里，只留下远处灯塔的光。这段戏没有台词，却把两人的关系交代得比任何对白都清楚。结尾处旅馆被拆除，蝉声突然中断，画面切到一片空白的天。",
    poster:
      "https://readdy.ai/api/search-image?query=Moody%20film%20poster%2C%20empty%20seaside%20train%20platform%20in%20summer%20haze%2C%20warm%20golden%20light%20and%20grey%20sky%2C%20cinematic%20grain%2C%20no%20text&width=600&height=900&seq=jpf-p05&orientation=portrait",
    stills: [
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20wooden%20inn%20corridor%20with%20open%20shoji%20doors%20and%20sea%20breeze%2C%20warm%20light%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p05-s1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20quiet%20beach%20at%20night%20with%20distant%20lighthouse%20beam%2C%20deep%20blue%20tonight%20tones%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p05-s2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20abandoned%20seaside%20hotel%20window%20with%20curtain%20blowing%2C%20sunlit%20dust%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p05-s3&orientation=landscape",
    ],
  },
  {
    id: "m06",
    title: "白色肌肤之诗",
    titleJa: "白い肌の詩",
    year: 2008,
    director: "大隅 修司",
    cast: ["篠田 真纪", "泽村 透"],
    runtime: 96,
    region: "京都",
    categories: ["classic", "romance"],
    tags: ["胶片", "和室", "昭和"],
    rating: 8.1,
    popularity: 80,
    releaseDate: "2008-05-16",
    synopsis:
      "一部以和室光影构成的旧作，几乎放弃了情节，只保留呼吸与季节。修复版重新调色后，纸门的白有了层次。",
    story:
      "这是大隅修司早期最具代表性的作品之一，全片只有四个场景，却依靠自然光的变化完成情绪推进。摄影机几乎不动，画面像一组连续的静物摄影。\n\n影片的修复版于2019年重新上映，调色师刻意保留了原底片的偏黄与轻微划痕，让纸门上的白不是纯白，而是带着时间感的暖白。对今天的观众来说，它更像一次关于「观看方式」的练习。",
    poster:
      "https://readdy.ai/api/search-image?query=Moody%20art%20house%20film%20poster%2C%20white%20linen%20sheet%20on%20a%20wooden%20floor%20with%20soft%20window%20light%2C%20minimal%20composition%2C%20cream%20and%20brown%20tones%2C%20no%20text&width=600&height=900&seq=jpf-p06&orientation=portrait",
    stills: [
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20shoji%20paper%20screen%20with%20tree%20shadows%20in%20a%20quiet%20tatami%20room%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p06-s1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20folded%20white%20cotton%20fabric%20on%20aged%20wood%2C%20soft%20diffused%20light%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p06-s2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20small%20courtyard%20garden%20with%20stone%20lantern%20and%20moss%2C%20overcast%20light%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p06-s3&orientation=landscape",
    ],
  },
  {
    id: "m07",
    title: "灯笼之夜",
    titleJa: "灯籠の夜",
    year: 2020,
    director: "柊 康平",
    cast: ["小野寺 澪", "森 圭吾"],
    runtime: 118,
    region: "金泽",
    categories: ["retro", "romance", "drama"],
    tags: ["祭典", "金泽", "夜景"],
    rating: 8.5,
    popularity: 87,
    releaseDate: "2020-08-14",
    synopsis:
      "祭典的三个夜晚，一条老街上的灯笼亮了又灭。两个人约定只在灯亮时相见，天亮之后谁也不认识谁。",
    story:
      "柊康平用大量夜戏建构出一个几乎不属于现代的城市：木格窗、石板路、被灯笼照亮的河道。影片的色彩管理非常克制，除了红色的灯笼与金色的光晕，其余部分被压到近乎单色。\n\n故事结构接近舞台剧，按三个夜晚分为三幕。第三幕开始时，其中一盏灯笼提前熄灭，观众立刻明白约定即将失效。结尾两人在桥上擦肩，镜头没有停留，直接切到清晨清扫街道的水声。",
    poster:
      "https://readdy.ai/api/search-image?query=Moody%20film%20poster%2C%20row%20of%20glowing%20red%20paper%20lanterns%20above%20a%20dark%20wooden%20street%20at%20night%2C%20warm%20gold%20light%2C%20cinematic%20grain%2C%20no%20text&width=600&height=900&seq=jpf-p07&orientation=portrait",
    stills: [
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20red%20paper%20lanterns%20reflected%20in%20a%20canal%20at%20night%2C%20warm%20glow%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p07-s1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20wooden%20bridge%20in%20a%20festival%20street%20with%20soft%20crowd%20bokeh%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p07-s2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20extinguished%20lantern%20on%20a%20dark%20wooden%20beam%2C%20single%20warm%20highlight%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p07-s3&orientation=landscape",
    ],
  },
  {
    id: "m08",
    title: "你不在的街道",
    titleJa: "きみのいない街",
    year: 2024,
    director: "川井 遥",
    cast: ["吉田 葵", "宮下 亮介"],
    runtime: 102,
    region: "东京",
    categories: ["new", "drama"],
    tags: ["都市", "孤独", "深夜"],
    rating: 9.0,
    popularity: 100,
    releaseDate: "2024-10-04",
    synopsis:
      "凌晨三点的东京，便利店、自动贩卖机和一条走了无数遍的路。一部关于「习惯一个人」的电影。",
    story:
      "川井遥把摄影机交给了夜班工作者：全片超过一半的镜头在凌晨一点到五点之间拍摄，自然光几乎不存在，只有招牌与贩卖机的冷光。城市在这种光线下显得陌生，却也因此诚实。\n\n影片没有明确的爱情线，主角与几位相遇者之间保持着随时可以结束的关系。最接近告白的一句台词，是「这家店的关东煮，萝卜比较好吃」。导演用这种日常到近乎残酷的细节，说明亲密其实是一种共同记忆的积累。",
    poster:
      "https://readdy.ai/api/search-image?query=Moody%20film%20poster%2C%20empty%20Tokyo%20backstreet%20at%203am%20with%20vending%20machine%20glow%2C%20rain%2C%20desaturated%20charcoal%20tones%2C%20cinematic%20grain%2C%20no%20text&width=600&height=900&seq=jpf-p08&orientation=portrait",
    stills: [
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20glowing%20vending%20machine%20on%20an%20empty%20night%20street%2C%20cold%20light%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p08-s1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20convenience%20store%20window%20at%20night%20seen%20from%20outside%2C%20warm%20interior%20light%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p08-s2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20wet%20asphalt%20with%20traffic%20light%20reflections%20at%20midnight%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p08-s3&orientation=landscape",
    ],
  },
  {
    id: "m09",
    title: "白昼之月",
    titleJa: "真昼の月",
    year: 2016,
    director: "真木 亮",
    cast: ["长谷川 雪", "冈田 慎"],
    runtime: 115,
    region: "神户",
    categories: ["noir", "drama"],
    tags: ["悬疑", "港城", "双线叙事"],
    rating: 8.3,
    popularity: 84,
    releaseDate: "2016-12-02",
    synopsis:
      "神户的一栋旧洋馆里，两个时间线交替推进。白天的月很淡，淡到几乎可以否认它的存在。",
    story:
      "影片采用双线结构，一条线发生在1989年，另一条在当下，两条线通过同一件家具与同一段旋律连接。真木亮刻意让两条线的色调几乎一致，观众必须依靠服装与画幅比例判断年代。\n\n悬疑部分并不依赖反转，而是依赖信息的不对等。当观众终于拼出完整图景时，会发现真相早在第一幕就被说出来了，只是当时没人愿意相信。",
    poster:
      "https://readdy.ai/api/search-image?query=Moody%20film%20poster%2C%20pale%20moon%20in%20a%20bright%20daytime%20sky%20above%20power%20lines%2C%20muted%20grey%20and%20gold%2C%20cinematic%20grain%2C%20no%20text&width=600&height=900&seq=jpf-p09&orientation=portrait",
    stills: [
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20old%20Western%20style%20Japanese%20villa%20interior%20with%20tall%20windows%2C%20dust%20light%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p09-s1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20antique%20wooden%20clock%20and%20photo%20frame%20on%20a%20sideboard%2C%20muted%20tones%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p09-s2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20Kobe%20harbor%20skyline%20in%20hazy%20afternoon%20light%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p09-s3&orientation=landscape",
    ],
  },
  {
    id: "m10",
    title: "丝",
    titleJa: "絲",
    year: 2013,
    director: "大隅 修司",
    cast: ["北川 沙织", "河合 直人"],
    runtime: 89,
    region: "京都",
    categories: ["classic", "drama"],
    tags: ["实验", "静物", "极简"],
    rating: 8.0,
    popularity: 72,
    releaseDate: "2013-04-19",
    synopsis:
      "一根丝线的七次缠绕，七个短篇。大隅修司用最少的元素完成了一次关于欲望与克制的实验。",
    story:
      "全片由七个十分钟左右的短篇组成，每一段都以「丝」为核心意象：缝衣线、琴弦、蜘蛛丝、风筝线。段落之间没有情节关联，但共享同一套镜头语言：特写、浅景深、几乎没有配乐。\n\n这是大隅作品中形式感最强的一部。第五段的黑场长达四十秒，影院放映时曾有观众以为放映机故障。导演在访谈中说，那段黑场是留给观众自己想象的部分。",
    poster:
      "https://readdy.ai/api/search-image?query=Moody%20art%20house%20film%20poster%2C%20tangled%20black%20silk%20thread%20on%20aged%20wooden%20surface%2C%20single%20warm%20light%2C%20deep%20shadow%2C%20cinematic%20grain%2C%20no%20text&width=600&height=900&seq=jpf-p10&orientation=portrait",
    stills: [
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20close%20up%20of%20a%20spool%20of%20thread%20in%20low%20light%2C%20shallow%20depth%20of%20field%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p10-s1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20sewing%20machine%20needle%20and%20red%20fabric%20detail%2C%20warm%20lamp%20light%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p10-s2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20single%20thin%20thread%20backlit%20in%20a%20dark%20room%2C%20minimal%20composition%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p10-s3&orientation=landscape",
    ],
  },
  {
    id: "m11",
    title: "深红",
    titleJa: "深紅",
    year: 2024,
    director: "黑田 诚一",
    cast: ["佐伯 玲奈", "小柳 隼"],
    runtime: 126,
    region: "东京",
    categories: ["new", "noir", "drama"],
    tags: ["黑色电影", "霓虹", "复仇"],
    rating: 8.8,
    popularity: 97,
    releaseDate: "2024-11-29",
    synopsis:
      "新宿的一间旧影院即将停业，放映员在最后一周里发现了一卷不属于任何片单的胶片。",
    story:
      "黑田诚一回到他最熟悉的霓虹街区，这次把镜头对准一间即将关闭的单厅影院。红色丝绒座椅、剥落的金漆、永远卡带的放映机，构成全片最重要的视觉母题。\n\n影片的叙事像那卷来历不明的胶片一样断裂，观众需要自己拼接。当最后一夜放映结束，银幕上出现的画面与开场的第一个镜头完全相同，形成闭环。黑田说这是他写给影院的一封告别信。",
    poster:
      "https://readdy.ai/api/search-image?query=Moody%20noir%20film%20poster%2C%20crimson%20neon%20sign%20reflected%20in%20a%20wet%20window%2C%20dark%20interior%2C%20heavy%20shadows%2C%20cinematic%20grain%2C%20no%20text&width=600&height=900&seq=jpf-p11&orientation=portrait",
    stills: [
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20empty%20old%20cinema%20with%20red%20velvet%20seats%20and%20screen%20glow%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p11-s1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20film%20reel%20and%20projector%20in%20a%20dusty%20booth%2C%20warm%20light%20beam%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p11-s2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20rainy%20Shinjuku%20alley%20with%20red%20neon%20reflections%20at%20night%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p11-s3&orientation=landscape",
    ],
  },
  {
    id: "m12",
    title: "不眠港口",
    titleJa: "眠らない港",
    year: 2015,
    director: "真木 亮",
    cast: ["津田 龙", "白石 美绪"],
    runtime: 110,
    region: "横滨",
    categories: ["noir", "drama", "classic"],
    tags: ["港口", "走私", "群像"],
    rating: 8.2,
    popularity: 78,
    releaseDate: "2015-10-09",
    synopsis:
      "横滨港的夜班工人、报关员与一位不肯离开候船室的女人，在同一艘货轮靠岸的晚上交汇。",
    story:
      "影片的群像结构接近社会学观察，四条线索在同一个夜晚展开。真木亮把大部分预算花在实景拍摄上，仓库、吊车与雾中的集装箱构成了压迫感极强的空间。\n\n人物之间没有戏剧化的冲突，更多是互相让路。真正的转折来自一段广播：那艘货轮因故延迟入港十二小时。所有安排被打乱，也给了每个人一个重新选择的机会。",
    poster:
      "https://readdy.ai/api/search-image?query=Moody%20film%20poster%2C%20foggy%20container%20port%20at%20night%20with%20distant%20cranes%20and%20cold%20lamps%2C%20deep%20teal%20and%20crimson%2C%20cinematic%20grain%2C%20no%20text&width=600&height=900&seq=jpf-p12&orientation=portrait",
    stills: [
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20foggy%20shipping%20containers%20under%20sodium%20lamps%20at%20night%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p12-s1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20empty%20ferry%20terminal%20waiting%20room%20at%20night%20with%20fluorescent%20light%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p12-s2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20harbor%20water%20with%20oil%20sheen%20and%20reflected%20lights%20at%20night%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p12-s3&orientation=landscape",
    ],
  },
  {
    id: "m13",
    title: "柠檬季节",
    titleJa: "檸檬の季節",
    year: 2022,
    director: "早川 佳奈",
    cast: ["尾崎 千寻", "松冈 亮太"],
    runtime: 94,
    region: "濑户内",
    categories: ["romance", "new"],
    tags: ["岛屿", "夏天", "食物"],
    rating: 8.1,
    popularity: 83,
    releaseDate: "2022-05-13",
    synopsis:
      "濑户内海的小岛上，一间只卖柠檬水的店，一个夏天，和一份没有寄出的菜单。",
    story:
      "早川佳奈把这部片子拍得极轻：固定的机位、明亮的自然光、大量关于手的特写。摘柠檬、切片、挤汁，这些动作被反复呈现，几乎具有仪式感。\n\n两位主角的关系进展缓慢，更多是靠日常对话推进。影片里最好笑也最动人的一场戏，是两人为了争论柠檬水要不要加糖，从下午一直吵到天黑。",
    poster:
      "https://readdy.ai/api/search-image?query=Moody%20film%20poster%2C%20lemons%20on%20a%20sunlit%20kitchen%20table%20with%20sheer%20curtain%20shadow%2C%20warm%20yellow%20and%20cream%20tones%2C%20cinematic%20grain%2C%20no%20text&width=600&height=900&seq=jpf-p13&orientation=portrait",
    stills: [
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20glass%20of%20lemonade%20on%20a%20wooden%20counter%20with%20island%20light%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p13-s1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20lemon%20tree%20branches%20against%20a%20bright%20sky%20on%20a%20small%20island%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p13-s2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20small%20island%20pier%20at%20golden%20hour%20with%20gentle%20waves%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p13-s3&orientation=landscape",
    ],
  },
  {
    id: "m14",
    title: "星尘之床",
    titleJa: "星屑のベッド",
    year: 2011,
    director: "柊 康平",
    cast: ["森 圭吾", "小野寺 澪"],
    runtime: 108,
    region: "北海道",
    categories: ["romance", "classic"],
    tags: ["雪原", "星空", "公路"],
    rating: 8.4,
    popularity: 76,
    releaseDate: "2011-02-11",
    synopsis:
      "北海道的一间民宿，冬天只有一位客人。夜里她打开天窗，让整个星空落进房间。",
    story:
      "柊康平在这部作品中第一次大规模使用自然光夜戏。摄影组在零下十几度的雪原上等待云层散开，最长一次连续拍摄十四个小时。成片里的星空没有经过合成。\n\n影片的结构像一篇散文，由民宿主人的日记串起。没有激烈的冲突，只有一个外来者如何在极北的寂静里重新学习睡眠。",
    poster:
      "https://readdy.ai/api/search-image?query=Moody%20film%20poster%2C%20starry%20night%20sky%20over%20snowy%20Hokkaido%20field%2C%20distant%20warm%20cabin%20light%2C%20deep%20indigo%20and%20gold%2C%20cinematic%20grain%2C%20no%20text&width=600&height=900&seq=jpf-p14&orientation=portrait",
    stills: [
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20small%20wooden%20inn%20in%20snow%20at%20night%20with%20warm%20windows%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p14-s1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20skylight%20above%20a%20bed%20with%20starry%20sky%20visible%2C%20deep%20blue%20tones%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p14-s2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20snow%20covered%20road%20with%20headlights%20cutting%20through%20darkness%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p14-s3&orientation=landscape",
    ],
  },
  {
    id: "m15",
    title: "说谎者的吻",
    titleJa: "嘘つきの接吻",
    year: 2023,
    director: "川井 遥",
    cast: ["吉田 葵", "东出 真"],
    runtime: 101,
    region: "东京",
    categories: ["romance", "new", "drama"],
    tags: ["酒店", "谎言", "都市"],
    rating: 8.6,
    popularity: 93,
    releaseDate: "2023-03-17",
    synopsis:
      "两个人每周三在同一间酒店见面，各自说着完全不同版本的自己。谎言维持了关系，也消耗了它。",
    story:
      "川井遥把空间压缩到一间房、一张床、一扇窗。全片只有两处外景，都发生在深夜的便利店。剧本由两位演员即兴发展，很多台词保留了现场的犹豫与停顿。\n\n影片最锋利的部分在于它从不揭穿谎言。观众逐渐意识到，两个人其实早就知道对方在编故事，只是需要有人陪自己演下去。结尾一个拉开窗帘的动作，比任何分手台词都更残忍。",
    poster:
      "https://readdy.ai/api/search-image?query=Moody%20film%20poster%2C%20two%20empty%20wine%20glasses%20on%20a%20hotel%20nightstand%20with%20blurred%20city%20light%2C%20warm%20amber%20and%20shadow%2C%20cinematic%20grain%2C%20no%20text&width=600&height=900&seq=jpf-p15&orientation=portrait",
    stills: [
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20hotel%20room%20curtain%20half%20open%20with%20city%20night%20lights%2C%20warm%20lamp%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p15-s1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20rumpled%20white%20bed%20linen%20in%20soft%20morning%20light%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p15-s2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20empty%20late%20night%20convenience%20store%20aisle%20with%20cold%20light%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p15-s3&orientation=landscape",
    ],
  },
  {
    id: "m16",
    title: "海边来信",
    titleJa: "海辺の手紙",
    year: 2014,
    director: "佐野川 透",
    cast: ["森川 千夏", "安藤 修"],
    runtime: 113,
    region: "镰仓",
    categories: ["drama", "classic", "romance"],
    tags: ["书信", "镰仓", "回忆"],
    rating: 8.3,
    popularity: 74,
    releaseDate: "2014-09-05",
    synopsis:
      "镰仓的一间旧邮局要关门了，最后一封无法投递的信，把两个陌生人带到了同一片海边。",
    story:
      "佐野川透难得拍了一部结构完整的剧情片。旧邮局是叙事的中枢，所有人物都在这里短暂停留。影片用十六毫米胶片拍摄，颗粒明显，海边的白墙在正午几乎过曝。\n\n信的收件人早已搬离，两位主角决定一起把信送到旧地址。这段公路行程占了影片三分之一，途中他们几乎没有谈论信的内容，只谈论各自的家人。",
    poster:
      "https://readdy.ai/api/search-image?query=Moody%20film%20poster%2C%20old%20handwritten%20letters%20and%20envelope%20on%20a%20weathered%20wooden%20bench%20by%20the%20sea%2C%20soft%20overcast%20light%2C%20cinematic%20grain%2C%20no%20text&width=600&height=900&seq=jpf-p16&orientation=portrait",
    stills: [
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20old%20wooden%20post%20office%20interior%20with%20sorted%20mail%20and%20warm%20light%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p16-s1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20Kamakura%20coastline%20with%20train%20passing%20by%20the%20sea%2C%20summer%20haze%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p16-s2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20stone%20stairs%20leading%20to%20a%20small%20shrine%20by%20the%20sea%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p16-s3&orientation=landscape",
    ],
  },
  {
    id: "m17",
    title: "等待春天",
    titleJa: "春を待つ",
    year: 2019,
    director: "篠原 直",
    cast: ["白石 美绪", "井上 隼人"],
    runtime: 99,
    region: "北海道",
    categories: ["drama", "romance"],
    tags: ["雪", "家庭", "慢电影"],
    rating: 8.5,
    popularity: 81,
    releaseDate: "2019-03-01",
    synopsis:
      "雪化之前的两个月，一对分居的夫妻轮流照顾同一间空房子。春天来了，房子也要卖掉了。",
    story:
      "篠原直把时间拉得很长：烧水、铲雪、修一扇关不严的窗。影片中几乎没有配乐，环境音被放大到可以听见雪从屋檐落下的声音。\n\n两位主角的对话礼貌得近乎陌生，所有情绪都藏在动作里。最后一幕两人一起把家具搬上车，谁也没有回头。镜头留在空掉的客厅，窗外开始滴水。",
    poster:
      "https://readdy.ai/api/search-image?query=Moody%20film%20poster%2C%20bare%20tree%20branches%20with%20melting%20snow%20in%20early%20spring%20light%2C%20pale%20sky%2C%20muted%20brown%20tones%2C%20cinematic%20grain%2C%20no%20text&width=600&height=900&seq=jpf-p17&orientation=portrait",
    stills: [
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20empty%20Japanese%20living%20room%20with%20packed%20boxes%20and%20winter%20light%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p17-s1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20melting%20snow%20dripping%20from%20a%20roof%20edge%2C%20close%20up%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p17-s2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20snowy%20suburban%20street%20in%20Hokkaido%20at%20dusk%2C%20warm%20window%20lights%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p17-s3&orientation=landscape",
    ],
  },
  {
    id: "m18",
    title: "沙的记忆",
    titleJa: "砂の記憶",
    year: 2012,
    director: "大隅 修司",
    cast: ["津田 龙", "北川 沙织"],
    runtime: 105,
    region: "鸟取",
    categories: ["drama", "retro", "classic"],
    tags: ["沙丘", "公路", "时间"],
    rating: 7.9,
    popularity: 68,
    releaseDate: "2012-08-24",
    synopsis:
      "鸟取沙丘旁的一间小旅馆，一位每年夏天都来的客人，和一本没人认领的留言簿。",
    story:
      "影片从一本留言簿开始，用不同年份的笔迹串起十几个夏天。大隅修司少见地使用了旁白，但旁白并不解释情节，只朗读留言簿上的文字。\n\n沙丘是全片最重要的意象：风一吹，昨天的痕迹就消失了。结尾镜头对着沙面持续了将近两分钟，观众会看到新的脚印一点点被抹平。",
    poster:
      "https://readdy.ai/api/search-image?query=Moody%20film%20poster%2C%20wind%20ripples%20on%20a%20vast%20sand%20dune%20at%20sunset%2C%20long%20shadows%2C%20warm%20ochre%20and%20charcoal%2C%20cinematic%20grain%2C%20no%20text&width=600&height=900&seq=jpf-p18&orientation=portrait",
    stills: [
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20vast%20sand%20dune%20ridges%20under%20late%20afternoon%20light%2C%20minimal%20desert%20landscape%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p18-s1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20open%20guestbook%20on%20a%20wooden%20desk%20with%20handwriting%2C%20warm%20lamp%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p18-s2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20small%20inn%20by%20sand%20dunes%20with%20single%20lit%20window%20at%20dusk%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p18-s3&orientation=landscape",
    ],
  },
  {
    id: "m19",
    title: "夜想曲",
    titleJa: "夜想曲",
    year: 2021,
    director: "真木 亮",
    cast: ["佐伯 玲奈", "河合 直人"],
    runtime: 117,
    region: "东京",
    categories: ["noir", "romance", "drama"],
    tags: ["钢琴", "夜", "记忆"],
    rating: 8.7,
    popularity: 89,
    releaseDate: "2021-10-22",
    synopsis:
      "一位不再登台的钢琴家，每晚在打烊后的酒吧弹同一首曲子。有人听了整整一年，只为等一个错音。",
    story:
      "真木亮把音乐当作叙事本身。全片出现的那首曲子共有七个版本，每个版本对应一段回忆。观众需要靠演奏速度与错音位置判断自己位于哪一段时间。\n\n影片的摄影极其克制，大部分时间只有一盏台灯。最后一场演奏，钢琴家第一次弹完整首曲子，没有错音，也没有人鼓掌。",
    poster:
      "https://readdy.ai/api/search-image?query=Moody%20noir%20film%20poster%2C%20grand%20piano%20silhouette%20in%20a%20dark%20room%20with%20one%20warm%20lamp%2C%20smoke%20in%20the%20air%2C%20cinematic%20grain%2C%20no%20text&width=600&height=900&seq=jpf-p19&orientation=portrait",
    stills: [
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20piano%20keys%20in%20low%20warm%20light%20with%20shallow%20depth%20of%20field%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p19-s1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20empty%20jazz%20bar%20after%20closing%20with%20single%20table%20lamp%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p19-s2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20sheet%20music%20scattered%20on%20a%20dark%20wooden%20floor%2C%20moody%20light%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p19-s3&orientation=landscape",
    ],
  },
  {
    id: "m20",
    title: "落花小巷",
    titleJa: "花降る路地",
    year: 2018,
    director: "柊 康平",
    cast: ["小野寺 澪", "青木 沙耶"],
    runtime: 96,
    region: "京都",
    categories: ["retro", "romance"],
    tags: ["樱花", "京都", "四季"],
    rating: 8.0,
    popularity: 71,
    releaseDate: "2018-04-06",
    synopsis:
      "京都一条只有十七户人家的小巷，樱花开了又落。四个季节，四段彼此错过的对话。",
    story:
      "影片按四季分为四章，同一批人物在不同季节里反复相遇。柊康平坚持在同一时间、同一机位拍摄每个季节的巷口，观众可以清楚看到光线角度的变化。\n\n第四章里，巷口的樱花树被修剪掉大半。人物的对话突然变得直接，因为他们都知道明年不会再有同样的花。",
    poster:
      "https://readdy.ai/api/search-image?query=Moody%20film%20poster%2C%20falling%20cherry%20blossom%20petals%20in%20a%20narrow%20wooden%20Kyoto%20lane%20at%20dusk%2C%20warm%20gold%20lantern%20light%2C%20cinematic%20grain%2C%20no%20text&width=600&height=900&seq=jpf-p20&orientation=portrait",
    stills: [
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20narrow%20Kyoto%20lane%20with%20cherry%20blossoms%20and%20wooden%20facades%2C%20spring%20light%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p20-s1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20petals%20floating%20on%20a%20stone%20water%20basin%2C%20close%20up%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p20-s2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20trimmed%20cherry%20tree%20branch%20in%20a%20quiet%20alley%20at%20dusk%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p20-s3&orientation=landscape",
    ],
  },
  {
    id: "m21",
    title: "静默的火焰",
    titleJa: "静かな炎",
    year: 2024,
    director: "早川 佳奈",
    cast: ["尾崎 千寻", "东出 真"],
    runtime: 111,
    region: "福冈",
    categories: ["new", "drama"],
    tags: ["小城", "家庭", "克制"],
    rating: 8.9,
    popularity: 92,
    releaseDate: "2024-06-21",
    synopsis:
      "福冈郊外的一间旧食堂，母女两人在同一口灶台前工作了二十年。一场拆迁通知打破了沉默。",
    story:
      "早川佳奈第一次把镜头对准家庭关系。食堂的厨房是全片唯一的战场，蒸汽、油声与刀具的节奏取代了对白。母女之间的争执几乎都发生在备菜的过程中，谁也没有停下手里的活。\n\n影片最精彩的调度出现在中段：两人隔着出餐口说话，视线始终没有交汇。拆迁那天，母亲照常开门营业，一直到夜里十一点。",
    poster:
      "https://readdy.ai/api/search-image?query=Moody%20film%20poster%2C%20small%20flame%20of%20a%20lighter%20in%20a%20dark%20room%2C%20glowing%20embers%20and%20smoke%2C%20deep%20orange%20and%20black%2C%20cinematic%20grain%2C%20no%20text&width=600&height=900&seq=jpf-p21&orientation=portrait",
    stills: [
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20old%20Japanese%20diner%20kitchen%20with%20steam%20and%20warm%20light%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p21-s1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20gas%20burner%20flame%20under%20a%20worn%20pot%20in%20low%20light%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p21-s2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20empty%20diner%20counter%20with%20stools%20at%20night%2C%20single%20fluorescent%20tube%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p21-s3&orientation=landscape",
    ],
  },
  {
    id: "m22",
    title: "月之背面",
    titleJa: "月の裏側",
    year: 2017,
    director: "黑田 诚一",
    cast: ["水野 香织", "小柳 隼"],
    runtime: 124,
    region: "东京",
    categories: ["noir", "drama"],
    tags: ["公寓", "悬疑", "心理"],
    rating: 8.4,
    popularity: 82,
    releaseDate: "2017-11-10",
    synopsis:
      "一栋只有六户人家的旧公寓，楼梯间的灯坏了三个月。有人开始怀疑，住在顶楼的人并不存在。",
    story:
      "黑田诚一用极端的空间限制完成这部作品：九成以上的镜头在楼梯间与走廊里拍摄。声音设计是全片的主角，脚步声、门锁声、水管声构成了另一条叙事线。\n\n影片始终不给答案。最后一场戏，主角站在顶楼门前，手停在门把上，画面切黑。片尾字幕结束后有一段三秒的空镜，走廊尽头多了一双鞋。",
    poster:
      "https://readdy.ai/api/search-image?query=Moody%20film%20poster%2C%20dark%20staircase%20winding%20upward%20with%20a%20single%20window%20moonbeam%2C%20charcoal%20and%20cold%20grey%20tones%2C%20cinematic%20grain%2C%20no%20text&width=600&height=900&seq=jpf-p22&orientation=portrait",
    stills: [
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20dim%20apartment%20stairwell%20with%20broken%20light%20and%20long%20shadows%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p22-s1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20row%20of%20apartment%20mailboxes%20in%20a%20dark%20entrance%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p22-s2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20a%20pair%20of%20shoes%20left%20at%20the%20end%20of%20a%20dark%20corridor%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p22-s3&orientation=landscape",
    ],
  },
  {
    id: "m23",
    title: "红线去向",
    titleJa: "赤い糸の行方",
    year: 2020,
    director: "小林 澪",
    cast: ["西岛 玲", "冈田 慎"],
    runtime: 103,
    region: "大阪",
    categories: ["romance", "drama"],
    tags: ["大阪", "老街", "命运"],
    rating: 8.2,
    popularity: 86,
    releaseDate: "2020-02-14",
    synopsis:
      "大阪下町的一条商店街要拆了。一间开了六十年的线铺，把最后一批红线送给了街坊。",
    story:
      "小林澪的镜头这次离开京都，进入大阪更嘈杂的市井空间。商店街的广播、自行车的铃声、邻居的拌嘴，构成了影片温暖的底色。\n\n红线是一个太明显的隐喻，导演却处理得克制：没有人真的提起命运，大家只是把线系在门把、车把和手腕上。拆迁前夜，整条街的红色在路灯下亮起来。",
    poster:
      "https://readdy.ai/api/search-image?query=Moody%20film%20poster%2C%20red%20thread%20tied%20around%20an%20old%20doorknob%20in%20a%20dim%20corridor%2C%20warm%20crimson%20glow%2C%20cinematic%20grain%2C%20no%20text&width=600&height=900&seq=jpf-p23&orientation=portrait",
    stills: [
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20old%20thread%20shop%20with%20colorful%20spools%20on%20wooden%20shelves%2C%20warm%20light%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p23-s1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20covered%20shopping%20arcade%20in%20Osaka%20at%20evening%20with%20shop%20lights%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p23-s2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20red%20threads%20tied%20on%20a%20bicycle%20handlebar%20in%20warm%20streetlight%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p23-s3&orientation=landscape",
    ],
  },
  {
    id: "m24",
    title: "冬日吐息",
    titleJa: "冬の吐息",
    year: 2023,
    director: "篠原 直",
    cast: ["坂本 未来", "安藤 修"],
    runtime: 97,
    region: "北海道",
    categories: ["new", "romance"],
    tags: ["雪夜", "温泉", "慢热"],
    rating: 8.3,
    popularity: 90,
    releaseDate: "2023-12-08",
    synopsis:
      "暴雪封路的夜晚，一间温泉旅馆只剩两位客人。他们在走廊尽头共用一台老式暖炉，什么也没说。",
    story:
      "篠原直把这部片子拍得极安静。旅馆外的风雪被隔在玻璃之后，室内只有暖炉的响声。两位主角的对白加起来不到一百句。\n\n影片用大量空镜记录时间流逝：雪落在窗台，热水冒出的蒸汽，走廊上逐渐熄灭的灯。天亮时道路打通，两人各自离开，谁也没有留下联系方式。",
    poster:
      "https://readdy.ai/api/search-image?query=Moody%20film%20poster%2C%20frozen%20window%20with%20breath%20fog%20and%20blurred%20warm%20interior%20light%2C%20cold%20blue%20grey%20and%20amber%2C%20cinematic%20grain%2C%20no%20text&width=600&height=900&seq=jpf-p24&orientation=portrait",
    stills: [
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20snow%20falling%20outside%20a%20ryokan%20window%20with%20warm%20paper%20lamp%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p24-s1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20old%20kerosene%20heater%20glowing%20in%20a%20dark%20wooden%20corridor%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p24-s2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20steam%20rising%20from%20an%20outdoor%20hot%20spring%20in%20snow%2C%20film%20grain%2C%20no%20text&width=800&height=450&seq=jpf-p24-s3&orientation=landscape",
    ],
  },
];